import { Switch } from "react-router-dom";
import { ACESSOS } from "../Acessos";
import PrivatedRoute from "../PrivatedRoute";
import GestaoAudiencia from "../../Pages/Automacao/GestaoAudiencia";
import GestaoContatosNaAudiencia from "../../Pages/Automacao/GestaoAudiencia/GestaoContatosNaAudiencia";
import VincularDesvincularContatos from "../../Pages/Automacao/GestaoAudiencia/GestaoContatosNaAudiencia/VincularDesvincularContatos";
import { ConfiguracaoDeRegua } from "../../Pages/Automacao/Regua/ConfiguracaoDeRegua";
import EditarRegua from "../../Pages/Automacao/Regua/EditarRegua";
import { GestaoDasReguas } from "../../Pages/Automacao/Regua/GestaoDasReguas";
import RelatoriosDeRegua from "../../Pages/Automacao/Regua/RelatoriosDeRegua";
import Formularios from "../../Pages/Automacao/Formularios";
import RelatoriosBIAutomacao from "../../Pages/Automacao/Relatorios/RelatoriosBI";

export default function RotasAutomacao() {
    return (
        <Switch>
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.AUDIENCIA.DS_PATH}
                component={GestaoAudiencia}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.AUDIENCIA.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.AUDIENCIA_CONTATO.DS_PATH}
                component={GestaoContatosNaAudiencia}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.AUDIENCIA_CONTATO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.VINCULAR_CONTATOS.DS_PATH}
                component={VincularDesvincularContatos}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.VINCULAR_CONTATOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.DESVINCULAR_CONTATOS.DS_PATH}
                component={VincularDesvincularContatos}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.DESVINCULAR_CONTATOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.REGUA.CONFIG.DS_PATH}
                exact
                component={ConfiguracaoDeRegua}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.REGUA.CONFIG.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.REGUA.GESTAO.DS_PATH}
                exact
                component={GestaoDasReguas}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.REGUA.GESTAO.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS.DS_PATH}
                exact
                component={RelatoriosDeRegua}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS_BI.DS_PATH}
                exact
                component={RelatoriosBIAutomacao}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS_BI.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.REGUA.EDITAR.DS_PATH}
                exact
                component={EditarRegua}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.REGUA.EDITAR.ID_TELA}
            />
            <PrivatedRoute
                path={ACESSOS.AUTOMACAO.TELAS.FORMULARIOS.DS_PATH}
                exact
                component={Formularios}
                isPrivate
                idTela={ACESSOS.AUTOMACAO.TELAS.FORMULARIOS.ID_TELA}
            />
        </Switch>
    );
}
